function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const accordionAnimations = new WeakMap();
const accordionMotionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');

function getAccordionContent(detailsEl) {
  const summaryEl = detailsEl.querySelector('summary');
  if (!summaryEl) return null;

  const contentEl = summaryEl.nextElementSibling;
  return contentEl && contentEl.classList.contains('accordion__content') ? contentEl : null;
}

function getAccordionStyles(contentEl) {
  const computedStyles = window.getComputedStyle(contentEl);

  return {
    height: computedStyles.height,
    opacity: computedStyles.opacity,
    paddingTop: computedStyles.paddingTop,
    paddingBottom: computedStyles.paddingBottom,
    marginBottom: computedStyles.marginBottom,
  };
}

function applyAccordionStyles(contentEl, styles) {
  contentEl.style.overflow = 'hidden';
  contentEl.style.height = styles.height;
  contentEl.style.opacity = styles.opacity;
  contentEl.style.paddingTop = styles.paddingTop;
  contentEl.style.paddingBottom = styles.paddingBottom;
  contentEl.style.marginBottom = styles.marginBottom;
}

function clearAccordionStyles(contentEl) {
  contentEl.style.overflow = '';
  contentEl.style.height = '';
  contentEl.style.opacity = '';
  contentEl.style.paddingTop = '';
  contentEl.style.paddingBottom = '';
  contentEl.style.marginBottom = '';
}

function stopAccordionAnimation(detailsEl) {
  const activeAnimation = accordionAnimations.get(detailsEl);
  if (!activeAnimation) return;

  const contentEl = getAccordionContent(detailsEl);
  if (contentEl) {
    applyAccordionStyles(contentEl, getAccordionStyles(contentEl));
  }

  activeAnimation.animation.cancel();
  accordionAnimations.delete(detailsEl);
}

function animateAccordion(detailsEl, shouldOpen) {
  const contentEl = getAccordionContent(detailsEl);
  if (!contentEl) return;

  const isAnimating = accordionAnimations.has(detailsEl);
  const wasOpen = detailsEl.hasAttribute('open');

  if (isAnimating) {
    stopAccordionAnimation(detailsEl);
  }

  if (shouldOpen) {
    detailsEl.setAttribute('open', '');
  }

  const expandedStyles = getAccordionStyles(contentEl);
  expandedStyles.height = `${contentEl.scrollHeight}px`;
  expandedStyles.opacity = '1';

  const collapsedStyles = {
    height: '0px',
    opacity: '0',
    paddingTop: '0px',
    paddingBottom: '0px',
    marginBottom: '0px',
  };

  const startStyles = shouldOpen
    ? wasOpen || isAnimating
      ? getAccordionStyles(contentEl)
      : collapsedStyles
    : getAccordionStyles(contentEl);
  const endStyles = shouldOpen ? expandedStyles : collapsedStyles;

  applyAccordionStyles(contentEl, startStyles);

  const animation = contentEl.animate([startStyles, endStyles], {
    duration: shouldOpen ? 260 : 220,
    easing: shouldOpen ? 'cubic-bezier(0.22, 1, 0.36, 1)' : 'cubic-bezier(0.4, 0, 1, 1)',
    fill: 'forwards',
  });

  accordionAnimations.set(detailsEl, {
    animation,
    opening: shouldOpen,
  });

  animation.onfinish = () => {
    if (!shouldOpen) {
      detailsEl.removeAttribute('open');
    }

    clearAccordionStyles(contentEl);
    accordionAnimations.delete(detailsEl);
  };

  animation.oncancel = () => {
    accordionAnimations.delete(detailsEl);
  };
}

function isSingleOpenProductAccordion(detailsEl) {
  return detailsEl.matches('.product__accordion.accordion.quick-add-hidden > details');
}

function closeSiblingProductAccordions(detailsEl) {
  if (!isSingleOpenProductAccordion(detailsEl)) return;

  const productSection = detailsEl.closest('[id^="MainProduct-"], product-info');
  if (!productSection) return;

  productSection.querySelectorAll('.product__accordion.accordion.quick-add-hidden > details[open]').forEach((openDetailsEl) => {
    if (openDetailsEl === detailsEl) return;

    const summaryEl = openDetailsEl.querySelector('summary');
    const contentEl = getAccordionContent(openDetailsEl);

    if (accordionMotionPreference.matches || !contentEl) {
      openDetailsEl.removeAttribute('open');
      if (summaryEl) summaryEl.setAttribute('aria-expanded', 'false');
      return;
    }

    animateAccordion(openDetailsEl, false);
    if (summaryEl) summaryEl.setAttribute('aria-expanded', 'false');
  });
}

document.addEventListener('click', (event) => {
  const summaryEl = event.target.closest('.accordion summary');
  if (!summaryEl || accordionMotionPreference.matches) return;

  const detailsEl = summaryEl.parentElement;
  if (!(detailsEl instanceof HTMLDetailsElement) || !summaryEl.closest('.accordion')) return;

  const contentEl = getAccordionContent(detailsEl);
  if (!contentEl) return;

  event.preventDefault();

  const activeAnimation = accordionAnimations.get(detailsEl);
  const shouldOpen = activeAnimation ? !activeAnimation.opening : !detailsEl.hasAttribute('open');

  if (shouldOpen) {
    closeSiblingProductAccordions(detailsEl);
  }

  animateAccordion(detailsEl, shouldOpen);
});

document.addEventListener('toggle', (event) => {
  const detailsEl = event.target;
  if (!(detailsEl instanceof HTMLDetailsElement) || !detailsEl.hasAttribute('open')) return;

  closeSiblingProductAccordions(detailsEl);
});

const megaMenuMq = window.matchMedia('(min-width: 990px)');
let megaMenuHoverBound = false;
const megaMenuAnimations = new WeakMap();
const megaMenuCloseTimers = new WeakMap();
const MEGA_MENU_CLOSE_DELAY = 140;

function clearMegaMenuCloseTimer(detailsEl) {
  const closeTimer = megaMenuCloseTimers.get(detailsEl);
  if (closeTimer) {
    window.clearTimeout(closeTimer);
    megaMenuCloseTimers.delete(detailsEl);
  }
}

function setMegaMenuOpen(detailsEl, isOpen) {
  if (!megaMenuMq.matches && isOpen) return;
  const summaryEl = detailsEl.querySelector('summary');
  if (isOpen) {
    detailsEl.setAttribute('open', '');
    if (summaryEl) summaryEl.setAttribute('aria-expanded', 'true');
  } else {
    detailsEl.removeAttribute('open');
    if (summaryEl) summaryEl.setAttribute('aria-expanded', 'false');
  }
}

function stopMegaMenuAnimation(detailsEl) {
  const anim = megaMenuAnimations.get(detailsEl);
  if (anim) anim.animation.cancel();
  megaMenuAnimations.delete(detailsEl);

  const contentEl = detailsEl.querySelector('.mega-menu__content');
  if (contentEl) {
    contentEl.style.opacity = '';
    contentEl.style.transform = '';
    contentEl.style.transition = '';
  }
}

function animateMegaMenu(detailsEl, isOpen) {
  if (!megaMenuMq.matches && isOpen) return;
  if (isOpen) clearMegaMenuCloseTimer(detailsEl);

  const contentEl = detailsEl.querySelector('.mega-menu__content');
  if (!contentEl) {
    setMegaMenuOpen(detailsEl, isOpen);
    return;
  }

  const activeAnimation = megaMenuAnimations.get(detailsEl);
  const isCurrentlyOpen = detailsEl.hasAttribute('open');

  if (isOpen && isCurrentlyOpen) {
    if (!activeAnimation) return;
    if (!activeAnimation.opening) {
      stopMegaMenuAnimation(detailsEl);
      setMegaMenuOpen(detailsEl, true);
      return;
    }
  }

  if (!isOpen && !isCurrentlyOpen && !activeAnimation) return;

  stopMegaMenuAnimation(detailsEl);

  const openAnimation = contentEl.animate(
    [{ opacity: 0, transform: 'translateY(-1.5rem)' }, { opacity: 1, transform: 'translateY(0)' }],
    { duration: 220, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'forwards' }
  );

  if (isOpen) {
    setMegaMenuOpen(detailsEl, true);
    contentEl.style.transition = 'none';
    contentEl.style.opacity = 0;
    contentEl.style.transform = 'translateY(-1.5rem)';

    megaMenuAnimations.set(detailsEl, {
      animation: openAnimation,
      opening: true,
    });
    openAnimation.onfinish = () => {
      contentEl.style.opacity = '';
      contentEl.style.transform = '';
      contentEl.style.transition = '';
      megaMenuAnimations.delete(detailsEl);
    };
    return;
  }

  setMegaMenuOpen(detailsEl, true);
  contentEl.style.transition = 'none';
  contentEl.style.opacity = 1;
  contentEl.style.transform = 'translateY(0)';

  const closeAnimation = contentEl.animate(
    [{ opacity: 1, transform: 'translateY(0)' }, { opacity: 0, transform: 'translateY(-1.5rem)' }],
    { duration: 180, easing: 'cubic-bezier(0.4, 0, 1, 1)', fill: 'forwards' }
  );

  megaMenuAnimations.set(detailsEl, {
    animation: closeAnimation,
    opening: false,
  });
  closeAnimation.onfinish = () => {
    contentEl.style.opacity = '';
    contentEl.style.transform = '';
    contentEl.style.transition = '';
    setMegaMenuOpen(detailsEl, false);
    megaMenuAnimations.delete(detailsEl);
  };
}

function bindMegaMenuHover() {
  if (megaMenuHoverBound) return;
  document.querySelectorAll('details.mega-menu').forEach((detailsEl) => {
    detailsEl.addEventListener('mouseenter', () => {
      if (!megaMenuMq.matches) return;
      clearMegaMenuCloseTimer(detailsEl);
      animateMegaMenu(detailsEl, true);
    });
    detailsEl.addEventListener('mouseleave', () => {
      if (!megaMenuMq.matches) return;
      clearMegaMenuCloseTimer(detailsEl);
      const closeTimer = window.setTimeout(() => {
        megaMenuCloseTimers.delete(detailsEl);
        animateMegaMenu(detailsEl, false);
      }, MEGA_MENU_CLOSE_DELAY);
      megaMenuCloseTimers.set(detailsEl, closeTimer);
    });
  });
  megaMenuHoverBound = true;
}

document.addEventListener('DOMContentLoaded', bindMegaMenuHover);
if (document.readyState !== 'loading') bindMegaMenuHover();

megaMenuMq.addEventListener('change', () => {
  if (megaMenuMq.matches) return;
  document.querySelectorAll('details.mega-menu').forEach((detailsEl) => clearMegaMenuCloseTimer(detailsEl));
  document.querySelectorAll('details.mega-menu[open]').forEach((detailsEl) => setMegaMenuOpen(detailsEl, false));
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}


if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  isMobileFacetsDrawer() {
    return this.classList.contains('mobile-facets__wrapper');
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button.menu-drawer__close-button, button.mobile-facets__close-button').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    if (this.isMobileFacetsDrawer()) document.body.classList.add('mobile-facets-open');
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    if (this.isMobileFacetsDrawer()) document.body.classList.remove('mobile-facets-open');
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  syncTransparentHeaderState() {
    const stickyHeader = this.closest('sticky-header');
    if (stickyHeader && typeof stickyHeader.syncHeaderAppearance === 'function') {
      stickyHeader.syncHeaderAppearance();
      return;
    }

    const transparentHeader = document.querySelector('#site-header[data-index-transparent-header]');
    if (!transparentHeader) return;

    const drawerOpen =
      this.header?.classList.contains('menu-open') ||
      document.body.classList.contains(`overflow-hidden-${this.dataset.breakpoint}`) ||
      !!this.mainDetailsToggle?.classList.contains('menu-opening') ||
      this.mainDetailsToggle?.hasAttribute('open');
    transparentHeader.classList.toggle('site-header-transparent', !drawerOpen);
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    this.syncTransparentHeaderState();
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
    this.syncTransparentHeaderState();
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
      behavior: 'smooth',
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout (() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    this.filterImgVariant();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  filterImgVariant() {
    const sectionId = this.dataset.section;
    const galleries = document.querySelectorAll(`[id^="MediaGallery-${sectionId}"]`);
    if (!galleries.length) return;

    const allVariantOptionValues = new Set();
    this.getVariantData().forEach((variant) => {
      [variant.option1, variant.option2, variant.option3]
        .filter(Boolean)
        .forEach((opt) => allVariantOptionValues.add(String(opt).trim().toLowerCase()));
    });

    const variantOptionValues = [];
    if (this.currentVariant) {
      [this.currentVariant.option1, this.currentVariant.option2, this.currentVariant.option3]
        .filter(Boolean)
        .forEach((opt) => variantOptionValues.push(String(opt).trim().toLowerCase()));
    }

    const isVisibleForVariant = (alt) => {
      const altNorm = (alt || '').trim().toLowerCase();
      if (altNorm === '') return true;
      if (!allVariantOptionValues.has(altNorm)) return true;
      if (variantOptionValues.length === 0) return true;
      return variantOptionValues.some((v) => v === altNorm);
    };

    galleries.forEach((gallery) => {
      gallery.querySelectorAll('[data-media-alt]').forEach((el) => {
        const alt = el.getAttribute('data-media-alt');
        el.style.display = isVisibleForVariant(alt) ? 'block' : 'none';
      });

      const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
      if (!viewer) return;
      const slides = gallery.querySelectorAll('.product__media-item[data-media-id]');
      const firstVisible = Array.from(slides).find((s) => s.style.display !== 'none');
      if (firstVisible && gallery.setActiveMedia) {
        const mediaId = firstVisible.getAttribute('data-media-id');
        if (mediaId) gallery.setActiveMedia(mediaId, true);
      }
    });
  } 
  
  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const sectionId = this.dataset.section;
    const featuredMediaId = `${sectionId}-${this.currentVariant.featured_media.id}`;
    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${sectionId}"]`);
    mediaGalleries.forEach((mediaGallery) => {
      const featuredSlide = mediaGallery.querySelector(`.product__media-item[data-media-id="${featuredMediaId}"]`);
      const featuredVisible = !featuredSlide || featuredSlide.style.display !== 'none';
      if (featuredVisible) {
        mediaGallery.setActiveMedia(featuredMediaId, true);
      } else {
        const firstVisible = Array.from(mediaGallery.querySelectorAll('.product__media-item[data-media-id]'))
          .find((s) => s.style.display !== 'none');
        if (firstVisible && mediaGallery.setActiveMedia) {
          const mediaId = firstVisible.getAttribute('data-media-id');
          if (mediaId) mediaGallery.setActiveMedia(mediaId, true);
        }
      }
    });

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    if (newMediaModal) modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('visibility-hidden', pricePerItemSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
    if (pricePerItem) pricePerItem.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

(() => {
  if (window.__smCollectionViewByInit) return;
  window.__smCollectionViewByInit = true;
  const sectionViewByState = {};

  const desktopGridClasses = [
    'grid--1-col-desktop',
    'grid--2-col-desktop',
    'grid--3-col-desktop',
    'grid--4-col-desktop',
    'grid--5-col-desktop',
    'grid--6-col-desktop',
  ];

  function getGrid(sectionId) {
    return document.querySelector(`#product-grid[data-id="${sectionId}"]`) || document.getElementById('product-grid');
  }

  function getButtons(sectionId) {
    return Array.from(document.querySelectorAll(`[data-view-by-section="${sectionId}"]`));
  }

  function getDefaultColumns(sectionId) {
    const root = document.querySelector(`[data-view-by-root="${sectionId}"]`);
    return root?.dataset.defaultViewBy || '4';
  }

  function getCurrentColumns(sectionId) {
    return sectionViewByState[sectionId] || getDefaultColumns(sectionId);
  }

  function applyViewBy(sectionId, columns) {
    const grid = getGrid(sectionId);
    const buttons = getButtons(sectionId);
    if (!grid || !buttons.length || !columns) return;

    desktopGridClasses.forEach((className) => {
      grid.classList.remove(className);
    });
    grid.classList.add(`grid--${columns}-col-desktop`);

    buttons.forEach((button) => {
      const isActive = button.dataset.viewByColumns === columns;
      button.classList.toggle('active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function syncSection(sectionId) {
    const columns = getCurrentColumns(sectionId);
    requestAnimationFrame(() => applyViewBy(sectionId, columns));
  }

  function syncAllSections() {
    document.querySelectorAll('[data-view-by-root]').forEach((root) => {
      syncSection(root.dataset.viewByRoot);
    });
  }

  function handleViewByInteraction(target) {
    const button = target?.closest?.('[data-view-by-section]');
    if (!button) return false;

    const sectionId = button.dataset.viewBySection;
    const columns = button.dataset.viewByColumns;
    if (!sectionId || !columns) return false;

    sectionViewByState[sectionId] = columns;
    applyViewBy(sectionId, columns);
    return true;
  }

  document.addEventListener(
    'pointerdown',
    (event) => {
      if (!handleViewByInteraction(event.target)) return;
      event.preventDefault();
      event.stopPropagation();
    },
    true
  );

  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      if (!handleViewByInteraction(event.target)) return;
      event.preventDefault();
      event.stopPropagation();
    },
    true
  );

  function getArticleImageWrapperFromEventTarget(target) {
    const card = target?.closest?.('.article-card');
    if (!card) return null;
    return card.querySelector('.article-card__image-wrapper[data-article-url]');
  }

  function isPointInsideRect(event, rect) {
    return (
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom
    );
  }

  document.addEventListener(
    'click',
    (event) => {
      if (event.defaultPrevented) return;
      if (event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (event.target.closest('a, button, summary, input, select, textarea, label')) return;

      const imageWrapper = getArticleImageWrapperFromEventTarget(event.target);
      if (!imageWrapper) return;

      const articleUrl = imageWrapper.dataset.articleUrl;
      if (!articleUrl) return;

      if (!isPointInsideRect(event, imageWrapper.getBoundingClientRect())) return;

      window.location.href = articleUrl;
    },
    true
  );

  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      const imageWrapper = event.target.closest('.article-card__image-wrapper[data-article-url]');
      if (!imageWrapper) return;

      const articleUrl = imageWrapper.dataset.articleUrl;
      if (!articleUrl) return;

      event.preventDefault();
      window.location.href = articleUrl;
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAllSections);
  } else {
    syncAllSections();
  }

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(() => {
      syncAllSections();
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

(() => {
  if (window.__smInfiniteCollectionInit) return;
  window.__smInfiniteCollectionInit = true;

  const observedContainers = new WeakSet();

  function getSectionUrl(url, sectionId) {
    try {
      // FIX 1: Use window.location.href instead of origin to safely parse 
      // strictly relative paths like "?page=2" without losing the collection path.
      const nextUrl = new URL(url, window.location.href);
      nextUrl.searchParams.set('section_id', sectionId);
      return nextUrl.toString();
    } catch (error) {
      return null;
    }
  }

  function updateInfiniteScrollContainer(container, nextUrl) {
    if (!container) return;

    const status = container.querySelector('[data-infinite-scroll-status]');
    container.classList.remove('is-loading');

    if (nextUrl) {
      container.dataset.nextUrl = nextUrl;
      if (status) status.textContent = 'Loading more products...';
      return;
    }

    container.remove();
  }

  function appendNextPage(container, html) {
    const sectionId = container.dataset.sectionId;
    const currentGrid = document.querySelector(`#product-grid[data-id="${sectionId}"]`);
    const nextDocument = new DOMParser().parseFromString(html, 'text/html');
    const nextGrid = nextDocument.querySelector(`#product-grid[data-id="${sectionId}"]`);
    const nextPagination = nextDocument.querySelector(`[data-infinite-scroll][data-section-id="${sectionId}"]`);

    if (!currentGrid || !nextGrid) {
      updateInfiniteScrollContainer(container, null);
      return;
    }

    // FIX 2: If the pagination element was mistakenly nested inside the product grid 
    // by the Liquid template, remove it so we don't duplicate the trigger.
    if (nextPagination && nextGrid.contains(nextPagination)) {
      nextPagination.remove();
    }

    let newItemsAdded = 0;

    Array.from(nextGrid.children).forEach((item) => {
      // FIX 3: Check for duplicate products to break out-of-bounds Shopify loops
      let isDuplicate = false;

      // Quickest check: Use product ID if available
      if (item.id && document.getElementById(item.id)) {
        isDuplicate = true;
      } else {
        // Safe check: Grab the first link in the product card and see if that link is already in the grid
        const firstLink = item.matches('a[href]') ? item : item.querySelector('a[href]');
        if (firstLink) {
          const href = firstLink.getAttribute('href');
          if (href && href !== '#' && !href.startsWith('javascript:')) {
            const existingLinks = Array.from(currentGrid.querySelectorAll('a[href]')).map(a => a.getAttribute('href'));
            if (existingLinks.includes(href)) {
              isDuplicate = true;
            }
          }
        } else {
          // Fallback: If no links exist, check if exact HTML already exists
          const isExactMatch = Array.from(currentGrid.children).some(ex => ex.innerHTML === item.innerHTML);
          if (isExactMatch) isDuplicate = true;
        }
      }

      // Only append if it's a completely new product
      if (!isDuplicate) {
        currentGrid.appendChild(item);
        newItemsAdded++;
      }
    });

    if (typeof initializeScrollAnimationTrigger === 'function') {
      initializeScrollAnimationTrigger(currentGrid.innerHTML);
    }

    let nextUrl = nextPagination?.dataset.nextUrl || null;

    // FIX 4: If no new unique items were added (we fetched duplicate products), 
    // or if the URL hasn't changed, kill the infinite scroll loop.
    if (newItemsAdded === 0 || nextUrl === container.dataset.nextUrl) {
      nextUrl = null;
    }

    updateInfiniteScrollContainer(container, nextUrl);
  }

  function loadNextPage(container) {
    const nextUrl = container?.dataset.nextUrl;
    const sectionId = container?.dataset.sectionId;
    if (!container || !nextUrl || !sectionId || container.classList.contains('is-loading')) return;

    const sectionUrl = getSectionUrl(nextUrl, sectionId);
    if (!sectionUrl) return;

    const status = container.querySelector('[data-infinite-scroll-status]');
    container.classList.add('is-loading');
    if (status) status.textContent = 'Loading more products...';

    fetch(sectionUrl)
      .then((response) => response.text())
      .then((html) => {
        appendNextPage(container, html);
      })
      .catch((error) => {
        container.classList.remove('is-loading');
        if (status) status.textContent = '';
        console.error(error);
      });
  }

  function initInfiniteScroll(container) {
    if (!container || observedContainers.has(container)) return;
    observedContainers.add(container);

    const sentinel = container.querySelector('[data-infinite-scroll-sentinel]');
    if (!sentinel || typeof IntersectionObserver === 'undefined') return;

    new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          loadNextPage(container);
        });
      },
      { rootMargin: '0px 0px 400px 0px' }
    ).observe(sentinel);
  }

  function initAllInfiniteScroll() {
    document.querySelectorAll('[data-infinite-scroll]').forEach((container) => {
      initInfiniteScroll(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllInfiniteScroll);
  } else {
    initAllInfiniteScroll();
  }

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(() => {
      initAllInfiniteScroll();
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

function openCity(evt, cityName) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("fc-tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].classList.remove("active");
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(cityName).classList.add("active");
    evt.currentTarget.className += " active";
}
